import { render, staticRenderFns } from "./OscillographyAlarmChart.vue?vue&type=template&id=0a66e557&scoped=true&"
import script from "./OscillographyAlarmChart.vue?vue&type=script&lang=js&"
export * from "./OscillographyAlarmChart.vue?vue&type=script&lang=js&"
import style0 from "./OscillographyAlarmChart.vue?vue&type=style&index=0&id=0a66e557&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a66e557",
  null
  
)

export default component.exports